import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import InvoicesComp from './InvoicesComp'

function Invoices() {
    return (
        <div className='contentMain'>
            <LeftBar />
            <div className='theRightOne'>
                <div className='DashTop'>
                    <h1>Invoices</h1>
                    <NavBar />
                </div>
                <InvoicesComp />
            </div>
        </div>
    )
}

export default Invoices